import { forwardRef, type Ref, type SVGProps } from "react";
const IconSparkleFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M21 10.97h-.04A7.96 7.96 0 0 1 13 3v-.09a1 1 0 1 0-2 0V3a7.96 7.96 0 0 1-7.96 7.96H3a1 1 0 0 0 0 2h.04A7.96 7.96 0 0 1 11 20.92a1 1 0 0 0 2 0 7.96 7.96 0 0 1 7.96-7.95H21a1 1 0 0 0 0-2m4 12.07h-.04A3.96 3.96 0 0 1 21 19.1V19a1 1 0 0 0-2 0v.09a3.96 3.96 0 0 1-3.96 3.95H15a1 1 0 0 0 0 2h.04A3.96 3.96 0 0 1 19 29a1 1 0 0 0 2 0 3.96 3.96 0 0 1 3.96-3.96H25a1 1 0 0 0 0-2M27 13a3 3 0 1 0 0 6 3 3 0 1 0 0-6" />
  </svg>
);
const ForwardRef = forwardRef(IconSparkleFilledSVG);
ForwardRef.displayName = "IconSparkleFilled";
export { ForwardRef as IconSparkleFilled };
